module.exports = "/static/fonts/Framework7Icons-Regular.89deaa9.woff2";


//////////////////
// WEBPACK FOOTER
// ./~/framework7-icons/fonts/Framework7Icons-Regular.woff2
// module id = 1133
// module chunks = 2